<template>
    <div class="row">
        <!-- Segments -->
        <div class="col-xl-6 col-md-12">
            <div class="card">
                <div class="card-header">
                    <h5 class="header-case">Segments</h5>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="gf-table w-100">
                            <thead>
                                <tr>
                                    <th>{{ __('Category') }}</th>
                                    <th>{{ __('Mentions') }}</th>
                                    <th>{{ __('Score') }}</th>
                                </tr>
                            </thead>
                            <tbody v-for="(entity, key) in entities" v-show="Object.keys(entities[key]).length > 0">
                                <tr class="cursor-pointer" @click="expandEntities(key)">
                                    <th scope="row" class="text-truncate">
                                        {{ labelizeGeneral(key) }}
                                    </th>
                                    <td class="filled"></td>
                                    <td class="filled">
                                        {{
                                        expandedEntities == key
                                        ? "Hide"
                                        : "Expand"
                                        }}
                                    </td>
                                </tr>
                                <tr v-for="(stats, label) in entity" v-show="expandedEntities == key">
                                    <td class="text-truncate">
                                        {{ __(labelizeGeneral(label || "Unknown")) }}
                                        <i v-if="stats.entities_total_reviews > 0"
                                            class="fas fa-info info-circle align-middle" data-toggle="tooltip"
                                            data-placement="top" :title="(
                                            (stats.entities_total_reviews /
                                                stats.overall_total_reviews) *
                                            100
                                        ).toFixed(2) +
                                            '% of reviews have been auto-identified from text.'
                                            "></i>
                                    </td>
                                    <td>
                                        <h3 class="score d-inline">
                                            {{ stats.overall_total_reviews }}
                                        </h3>
                                        <i class="far fa-comment"></i>
                                        <span class="light-text-small" v-if="
                                        stats.overall_total_reviews &&
                                        stats.comparison &&
                                        stats.comparison.overall_total_reviews &&
                                        stats.overall_total_reviews !=
                                        stats.comparison.overall_total_reviews
                                    ">
                                            <span v-if="
                                            parseInt(stats.overall_total_reviews) >
                                            parseInt(stats.comparison.overall_total_reviews)
                                        ">
                                                <i class="ei-arrow_up"></i></span>
                                            <i v-if="
                                            parseInt(stats.overall_total_reviews) <
                                            parseInt(stats.comparison.overall_total_reviews)
                                        " class="ei-arrow_down"></i>
                                            {{
                                            parseInt(stats.comparison.overall_total_reviews)
                                            }}
                                        </span>
                                    </td>
                                    <td>
                                        <h3 class="score d-inline">
                                            {{ stats.overall_average_rating }}
                                        </h3>
                                        <span class="light-text">/5</span>
                                        <span class="light-text-small" v-if="
                                        stats.overall_average_rating &&
                                        stats.comparison &&
                                        stats.comparison.overall_average_rating &&
                                        stats.overall_average_rating !=
                                        stats.comparison.overall_average_rating
                                    ">
                                            <span v-if="
                                            parseFloat(stats.overall_average_rating) >
                                            parseFloat(stats.comparison.overall_average_rating)
                                        ">
                                                <i class="ei-arrow_up"></i></span>
                                            <i v-if="
                                            parseFloat(stats.overall_average_rating) <
                                            parseFloat(stats.comparison.overall_average_rating)
                                        " class="ei-arrow_down"></i>
                                            {{
                                            parseFloat(stats.comparison.overall_average_rating)
                                            }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- Reviews Map -->
        <div class="col-xl-6 col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="map-wrapper mt-3" @mouseout="hovered = null">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <h5 class="header-case mb-0">Reviews Map</h5>
                            <a href="#" class="blue-link" v-show="clicked !== null" @click.prevent="resetMap">
                                {{ __('RESET') }}
                            </a>
                        </div>
                        <div id="worldmap" style="width: 100%; height: 350px;"></div>
                        <div class="table-responsive">
                            <table class="gf-table w-100">
                                <thead>
                                    <tr>
                                        <th class="cursor-pointer" @click="setSort('country')">
                                            {{ __('Country') }}
                                            <i class="fa" :class="{
                                                'fa-arrow-up':
                                                    direction == 'asc',
                                                'fa-arrow-down':
                                                    direction == 'desc'
                                            }" v-if="sortBy == 'country'"></i>
                                        </th>
                                        <th class="cursor-pointer" @click="setSort('totalReviews')">
                                            {{ __('Reviews') }}
                                            <i class="fa" :class="{
                                                'fa-arrow-up':
                                                    direction == 'asc',
                                                'fa-arrow-down':
                                                    direction == 'desc'
                                            }" v-if="sortBy == 'totalReviews'"></i>
                                        </th>
                                        <th class="cursor-pointer" @click="setSort('averageRating')">
                                            {{ __('Score') }}
                                            <i class="fa" :class="{
                                                'fa-arrow-up':
                                                    direction == 'asc',
                                                'fa-arrow-down':
                                                    direction == 'desc'
                                            }" v-if="sortBy == 'averageRating'"></i>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="countries">
                                    <tr v-for="stat in countryStats" :class="{
                                        'master-row':
                                            hovered == stat.key ||
                                            clicked == stat.key,
                                        'd-none':
                                            clicked !== null &&
                                            clicked != stat.key
                                    }" class="country-row" :key="stat.key" v-show="stat.key !== ''">
                                        <td class="text-truncate">
                                            <a class="blue-link" href="#" @click.prevent="goToReviews(stat.key)"
                                                :title="labelizeGeneral(stat.key)">
                                                <img :src="'/assets/img/flags/' +
                                                    stat.key +
                                                    '.png'
                                                    " class="flag" :alt="labelizeGeneral(stat.key)" />
                                                {{ labelizeGeneral(stat.key) }}
                                                &nbsp;<i class="fa fa-arrow-right"></i>
                                            </a>
                                        </td>
                                        <td>
                                            <div class="d-flex align-items-center">
                                                <h3 class="score">
                                                    {{ stat.values.totalReviews }}
                                                </h3>
                                                <span class="light-text-small" v-if="
                                                    stat.values.totalReviews &&
                                                    stat.values.comparisonTotalReviews &&
                                                    stat.values.totalReviews !=
                                                    stat.values.comparisonTotalReviews
                                                ">
                                                    <span v-if="
                                                        parseFloat(stat.values.totalReviews) >
                                                        parseFloat(stat.values.comparisonTotalReviews)
                                                    ">
                                                        <i class="ei-arrow_up"></i></span>
                                                    <i v-if="
                                                        parseFloat(stat.values.totalReviews) <
                                                        parseFloat(stat.values.comparisonTotalReviews)
                                                    " class="ei-arrow_down"></i>
                                                    {{
                                                    parseFloat(stat.values.comparisonTotalReviews)
                                                    }}
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <h3 class="score d-inline">
                                                {{ stat.values.averageRating }}
                                            </h3>
                                            <span class="light-text">/5</span>
                                            <span class="light-text-small" v-if="
                                                stat.values.averageRating &&
                                                stat.values.comparisonAverageRating &&
                                                stat.values.averageRating !=
                                                stat.values.comparisonAverageRating
                                            ">
                                                <span v-if="
                                                    parseFloat(stat.values.averageRating) >
                                                    parseFloat(stat.values.comparisonAverageRating)
                                                ">
                                                    <i class="ei-arrow_up"></i></span>
                                                <i v-if="
                                                    parseFloat(stat.values.averageRating) <
                                                    parseFloat(stat.values.comparisonAverageRating)
                                                " class="ei-arrow_down"></i>
                                                {{
                                                    parseFloat(stat.values.comparisonAverageRating)
                                                }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="country-breakdown my-3 d-none" v-if="clicked !== null">
                            <h5 class="header-case">Country Breakdown</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import jQuery from "jquery";
window.jQuery = window.$ = jQuery;
require("jqvmap");
require("../../../../../node_modules/jqvmap/dist/maps/jquery.vmap.world.js");
export default {
    watch: {
        params: {
            handler(newValue, oldValue) {
                this.prepareMap(newValue);
                this.fetchEntities(newValue);
            },
            deep: true
        }
    },
    props: ["user", "teams", "params"],
    computed: {
        countryStats() {
            if (!this.countries.stats) return [];
            return this.countries.stats.sort((a, b) => {
                const key = this.sortBy;
                const aValue = key == "country" ? a.label : a.values[key];
                const bValue = key == "country" ? b.label : b.values[key];
                if (aValue > bValue) {
                    return this.direction == "desc" ? -1 : 1;
                }
                if (aValue < bValue) {
                    return this.direction == "desc" ? 1 : -1;
                }
                return 0;
            });
        }
    },
    data() {
        return {
            expandedEntities: "composition",
            annotation: "Room Types",
            entities: null,
            loading: false,
            countries: null,
            clicked: null,
            hovered: null,
            map: null,
            mapRendered: false,
            metadata: null,
            sortBy: "totalReviews",
            direction: "desc"
        };
    },
    mounted() {
        this.fetchEntities(this.params);
        this.prepareMap(this.params);
    },
    methods: {
        setSort(value) {
            if (this.sortBy == value) {
                this.direction = this.direction == "desc" ? "asc" : "desc";
                return;
            }
            this.sortBy = value;
            this.direction = "desc";
        },
        expandEntities(key) {
            if (key == this.expandedEntities) {
                this.expandedEntities = "";
                return;
            }

            this.expandedEntities = key;
        },
        prepareMap(params) {
            if (!params) {
                return;
            }

            const from = this.params.fromDate;
            const to = this.params.toDate;
            const comparisonFrom = this.params.comparisonFromDate;
            const comparisonTo = this.params.comparisonToDate;


            this.loading = true;

            var query = "?fromDate=" + from + "&toDate=" + to + "&comparisonFromDate=" + comparisonFrom +  "&comparisonToDate=" + comparisonTo;
            axios
                .get(`/api/stats/${Spark.state.currentTeam.id}/country${query}`)
                .then(response => {
                    this.countries = response.data;
                    let colors = this.getColorsFromCountryData(this.countries);
                    this.renderMap(colors);
                });
        },
        getColorsFromCountryData(countries) {
            var colorCountries = {};

            for (let country of countries.stats) {
                let key = country.key;
                if (key == "") {
                    continue;
                }
                colorCountries[key] = "#00aef1";
            }

            return colorCountries;
        },
        renderMap(colors) {
            var instance = this;

            if (this.mapRendered) {
                $("#worldmap").replaceWith(
                    '<div id="worldmap" style="height: 350px; width: 100%;"></div>'
                );
            }

            this.map = $("#worldmap").vectorMap({
                map: "world_en",
                backgroundColor: "#ffffff",
                borderColor: "#e9eaec",
                borderOpacity: 0.25,
                borderWidth: 1,
                color: "#BFEDFF",
                colors: colors,
                enableZoom: true,
                hoverColor: "#2d2d49",
                hoverOpacity: null,
                normalizeFunction: "linear",
                scaleColors: ["#b6d6ff", "#005ace"],
                selectedColor: "#2d2d49",
                selectedRegions: null,
                showTooltip: true,
                onRegionClick: (element, code, region) =>
                    instance.clickedMap(element, code, region),
                onRegionOver: (element, code, region) =>
                    instance.hoveredMap(element, code, region)
            });

            this.mapRendered = true;
        },
        resetMap() {
            this.clicked = null;
            const colors = this.getColorsFromCountryData(this.countries);
            this.renderMap(colors);
        },
        clickedMap(element, code, region) {
            if (this.clicked == code) {
                this.clicked = null;
                this.goToReviews(code);
                return;
            }
            this.clicked = code;
        },
        hoveredMap(element, code, region) {
            this.hovered = code;
        },
        fetchEntities(params) {
            if (!params) {
                return;
            }

            const from = this.params.fromDate;
            const to = this.params.toDate;
            const comparisonFrom = this.params.comparisonFromDate;
            const comparisonTo = this.params.comparisonToDate;

            this.loading = true;

            var query = "?fromDate=" + from + "&toDate=" + to + "&comparisonFromDate=" + comparisonFrom +  "&comparisonToDate=" + comparisonTo;
            axios
                .get(
                    `/api/reporting/${
                        Spark.state.currentTeam.id
                    }/entitiesBreakdown${query}`
                )
                .then(response => {
                    var instance = this;
                    setTimeout(function() {
                        instance.entities = response.data;
                        instance.loading = false;

                        Vue.nextTick(function() {
                            $('[data-toggle="tooltip"]').tooltip();
                        });
                    }, 300);
                });
        },
        goToReviews(countryCode) {
            let data = {
                terms: "",
                fromDate: this.params.fromDate,
                toDate: this.params.toDate,
                countryCode: countryCode
            };
            this.$eventHub.$emit("applyFilters", data);
            $('.spark-settings-tabs a[href$="#reviews"]').tab("show");
        }
    }
};
</script>

<style scoped>
.country-row .fa-arrow-right {
	display: none;
}
.country-row:hover .fa-arrow-right {
	display: inline;
}
.country-row td:nth-child(1) {
	white-space: nowrap;
}
</style>